import { render } from "./administrative-report-count.vue?vue&type=template&id=18d14cd2&scoped=true"
import script from "./administrative-report-count.vue?vue&type=script&lang=js"
export * from "./administrative-report-count.vue?vue&type=script&lang=js"

import "./administrative-report-count.vue?vue&type=style&index=0&id=18d14cd2&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d14cd2"]])

export default __exports__